import Vue from 'vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import { LMap, LMarker, LTileLayer } from 'vue2-leaflet'
import { LDrawToolbar } from 'vue2-leaflet-draw-toolbar'
import VueApexCharts from 'vue-apexcharts'
import VueDateTimePicker from 'vue-bootstrap-datetimepicker'
import VueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import VueEventCalendar from 'vue-event-calendar'
import 'vue-event-calendar/dist/style.css'
import VueGoodTable from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import VueHljs from 'vue-hljs'
import 'vue-hljs/dist/style.css'
import VueInputTag from 'vue-input-tag'
import VueInsProgressBar from 'vue-ins-progress-bar'
import JsonExcel from 'vue-json-excel'
import VueNotification from 'vue-notification'
import VueNVD3 from 'vue-nvd3'
import VueColorpicker from 'vue-pop-colorpicker'
import VueRouter from 'vue-router'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import VueSparkline from 'vue-sparklines'
import VueSweetalert2 from 'vue-sweetalert2'
import VueTheMask from 'vue-the-mask'
import VueDatepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import VueX from 'vuex'

import App from './App.vue'
import routes from './config/AppRoutes'
import { MAPS } from './envs'
import i18n from './i18n'
import VuePanel from './plugins/panel/'
import './scss/vue.scss'
import initSentry from './sentryInit'
// color admin css
import 'bootstrap-social/bootstrap-social.css'
import VueBootstrap from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'flag-icon-css/css/flag-icons.min.css'
import hljs from 'highlight.js'
import 'ionicons/dist/css/ionicons.min.css'
import 'leaflet/dist/leaflet.css'
import 'nvd3/build/nv.d3.min.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'simple-line-icons/css/simple-line-icons.css'
import 'sweetalert2/dist/sweetalert2.min.css'

// plugins
import Vueditor from '@agametov/vueditor'
// plugins css
import '@agametov/vueditor/dist/style/vueditor.min.css'
import VueCountdown from '@chenfengyuan/vue-countdown'
import '@fortawesome/fontawesome-free/css/all.min.css'

Vue.config.productionTip = false

Vue.use(VueX)
Vue.use(VueRouter)
Vue.use(VueBootstrap)
Vue.use(VueNVD3)
Vue.use(VueEventCalendar, { locale: 'en' })
Vue.use(VueSparkline)
Vue.use(Vueditor)
Vue.use(VueHljs, { hljs })
Vue.use(VueSweetalert2)
Vue.use(VueNotification)
Vue.use(VuePanel)
Vue.use(VueDateTimePicker)
Vue.use(VueGoodTable)
Vue.use(VueColorpicker)
Vue.use(VueTheMask)
Vue.use(VueGoogleMaps, {
    load: {
        key: MAPS.KEY,
        libraries: 'places, drawing',
    },
})
Vue.use(VueInsProgressBar, {
    position: 'fixed',
    show: true,
    height: '3px',
})

Vue.component('v-select', VueSelect)
Vue.component('datepicker', VueDatepicker)
Vue.component('input-tag', VueInputTag)
Vue.component('vue-slider', VueSlider)
Vue.component('vue-custom-scrollbar', VueCustomScrollbar)
Vue.component('apexchart', VueApexCharts)
Vue.component('date-range-picker', DateRangePicker)
Vue.component(VueCountdown.name, VueCountdown)
Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)
Vue.component('l-draw-toolbar', LDrawToolbar)
Vue.component('downloadExcel', JsonExcel)

initSentry(Vue)

const router = new VueRouter({
    routes,
})

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app')
